// React imports.
import React, { Component } from "react";

// App imports.
const TableLegend = () => (
  <div className="legendDiv">
      <ul className="legendList">
          <li className="blueBullet">Auto-populated from the LIHEAP Data Warehouse or provided from your LIHEAP Performance Data Form.</li>
          <li className="orangeBullet">Auto-populated from an outside data source, such as the SEDS.</li>
          <li className="yellowBullet">Information that you will need to provide from your own records.</li>
          <li className="greenBullet">No issue was found in the data entered for the corresponding fuel type.</li>
          <li className="redBullet">Issues were found in the data entered for the corresponding fuel type.</li>
      </ul>
  </div>
);

export default TableLegend;
